/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import Loading from '../../components/atoms/Loading'
import { Menu } from 'lucide-react'
import SelectInput from '../../components/Input/SelectInput'
import { firstLetterUpperCase } from '../../utils/TextFormatter'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

function CreateManualStockOpname() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState({
    create: false,
    cancel: false,
    error: false
  })
  const [collapsible, setCollapsible] = useState({})
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState({
    page: false,
    submit: false
  })
  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, page: true }))
      const payload = {
        warehouse_id: state?.warehouse_id,
        item_issues: state?.item_issues || []
      }
      const res = await api.post('/stock-opname/manual/racks', payload)
      const { data: dataResponse } = res.data
      setData(
        dataResponse?.map((item) => ({
          ...item,
          racks: item?.racks?.map((rack) => ({
            ...rack,
            pic: null,
            checker: null,
            item_code: item?.item_code
          }))
        }))
      )
      setCollapsible((prev) =>
        dataResponse
          ?.map((item) => item?.item_code)
          ?.reduce((acc, code) => {
            acc[code] = true
            return acc
          }, {})
      )
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      handleBack()
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, page: false }))
    }
  }
  const columnItems = [
    { key: 'item_code', label: 'Item Code' },
    { key: 'item_name', label: 'Item' },
    { key: 'batch', label: 'Batch' },
    {
      key: 'action',
      label: 'Action',
      className: 'd-flex justify-content-end',
      component: (value) => (
        <div key={value?.id} className="d-flex justify-content-end">
          <Button
            variant="transparent"
            className="btn-secondary"
            size="md"
            onClick={() =>
              setCollapsible((prev) => ({
                ...prev,
                [value.item_code]: !prev[value.item_code]
              }))
            }
          >
            <Menu size={14} />
          </Button>
        </div>
      )
    }
  ]
  const handleChangePicChecker = (itemCode, rackName, type, value) => {
    setData((prev) =>
      prev?.map((item) => {
        if (item?.item_code === itemCode) {
          return {
            ...item,
            racks: item?.racks?.map((rack) => {
              if (rack?.rack_name === rackName) {
                return {
                  ...rack,
                  [type]: value
                }
              }
              return rack
            })
          }
        }
        return item
      })
    )
  }
  const columnRacks = [
    { key: 'rack_name', label: 'Rack Name' },
    {
      key: 'rack_type',
      label: 'Rack Type',
      component: (value) => firstLetterUpperCase(value?.rack_type)
    },
    {
      key: 'checker',
      label: 'Checker',
      component: (value) => (
        <div key={value?.rack_name}>
          <SelectInput
            id={`${value.rack_name}-checker`}
            handleChange={(e) =>
              handleChangePicChecker(
                value?.item_code,
                value?.rack_name,
                'checker',
                e.target.value
              )
            }
            options={state?.checkers || []}
            value={value?.checker || ''}
          />
        </div>
      )
    },
    {
      key: 'pic',
      label: 'PIC',
      component: (value) => (
        <div key={value?.rack_name}>
          <SelectInput
            id={`${value.rack_name}-pic`}
            handleChange={(e) =>
              handleChangePicChecker(
                value?.item_code,
                value?.rack_name,
                'pic',
                e.target.value
              )
            }
            options={state?.pics || []}
            value={value?.pic || ''}
          />
        </div>
      )
    }
  ]
  const handleBack = (isCancel = null) => {
    navigate('/item-issue', {
      replace: true,
      state: isCancel
        ? {
            ...state,
            isCancel: true
          }
        : null
    })
  }
  const handleModal = (type = null) => {
    if (!type) {
      const trueKey = Object.keys(isOpen).find((key) => isOpen[key])
      if (trueKey) {
        setIsOpen((prev) => ({ ...prev, [trueKey]: !prev[trueKey] }))
      }
    } else {
      setIsOpen((prev) => ({
        ...prev,
        [type]: !prev[type]
      }))
    }
  }
  const ModalProp = useCallback(() => {
    if (isOpen.create) {
      return {
        title: 'Create Ticket',
        description: 'Make sure to assign checker and PIC to rack properly!',
        footer: (
          <div className="d-flex gap-2">
            <Button
              variant="transparent"
              disabled={loading.submit}
              onClick={() => handleModal()}
            >
              Cancel
            </Button>
            <Button
              variant="transparent"
              className={`${
                loading.submit
                  ? 'btn-secondary opacity-25'
                  : 'btn-primary-orange'
              }`}
              disabled={loading.submit}
              onClick={() => onSubmit(true)}
            >
              {loading.submit ? 'Loading...' : 'Create'}
            </Button>
          </div>
        )
      }
    }
    if (isOpen.cancel) {
      return {
        title: 'Cancel?',
        description: 'All data will be deleted, cancel creating ticket?',
        footer: (
          <div className="d-flex gap-2">
            <Button variant="transparent" onClick={() => handleModal()}>
              Continue Creating
            </Button>
            <Button
              variant="transparent"
              className="btn-primary-orange"
              onClick={() => handleBack(true)}
            >
              Cancel
            </Button>
          </div>
        )
      }
    }
    if (isOpen.error) {
      return {
        title: 'Action failed!',
        description: 'Please complete cycle count first!',
        footer: (
          <div className="d-flex gap-2">
            <Button
              variant="transparent"
              className="btn-primary-orange"
              onClick={() => handleModal()}
            >
              OK
            </Button>
          </div>
        )
      }
    }
    return {
      title: '',
      description: '',
      footer: null
    }
  }, [isOpen, loading.submit])

  const buttonCreateProp = useCallback(() => {
    if (
      data
        ?.flatMap((item) => item?.racks)
        ?.filter((rack) => !rack?.checker || !rack?.pic)?.length > 0
    )
      return true
    return false
  }, [data])

  const onSubmit = async () => {
    try {
      if (!state?.warehouse_id) {
        toast.error('Please select a warehouse', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        return
      }
      setLoading((prevLoading) => ({ ...prevLoading, submit: true }))
      const payload = {
        warehouse_id: state?.warehouse_id,
        batches: data?.map((item) => {
          return {
            batch: item.batch,
            racks: item?.racks?.map((rack) => ({
              rack_name: rack.rack_name,
              pic_id: rack?.pic,
              checker_id: rack?.checker
            }))
          }
        })
      }
      const res = await api.post('/stock-opname/manual', payload)
      const { data: dataResponse } = res.data
      if (dataResponse) {
        toast.success('Stock Opname Manual Created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate('/stock-opname/manual-stock-opname', {
          replace: true,
          state: null
        })
        return
      }
    } catch (error) {
      handleModal()
      setTimeout(() => {
        handleModal('error')
      }, 1000)
    } finally {
      setIsOpen((prev) => ({ ...prev, create: false }))
      setLoading((prevLoading) => ({ ...prevLoading, submit: false }))
    }
  }

  useEffect(() => {
    fetchData()
  }, [state])
  if (loading.page) {
    return <Loading />
  }
  return (
    <>
      <Toaster />
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col
            md={12}
            className="d-flex justify-content-between align-items-start"
          >
            <div className="d-flex flex-column justify-content-start">
              <h4
                style={headerTitleStyle}
                className="d-flex align-items-center gap-2"
              >
                Create Manual Stock Opname
              </h4>
            </div>
            <div
              className="d-flex flex-row align-items-center justify-content-end gap-2"
              style={{ marginTop: '2.3rem' }}
            >
              <Button variant="dark" onClick={() => handleModal('cancel')}>
                Back
              </Button>
              <Button
                variant="transparent"
                className={
                  buttonCreateProp()
                    ? 'btn-secondary opacity-25'
                    : 'btn-primary-orange'
                }
                disabled={buttonCreateProp()}
                onClick={() => handleModal('create')}
              >
                Create
              </Button>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Col md={12}>
            <Table
              hover
              responsive
              className="shadow-sm bg-white"
              style={{
                fontSize: '13px',
                borderRadius: '12px',
                overflow: 'hidden',
                marginBottom: 0
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columnItems.map((column) => (
                    <th
                      className={`align-middle p-2 ${column.className}`}
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      <span>{column.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.length === 0 && (
                  <tr>
                    <td
                      colSpan={columnItems.length}
                      className="p-2 text-center"
                    >
                      No data
                    </td>
                  </tr>
                )}
                {data?.length > 0 &&
                  data.map((item, index) => {
                    return (
                      <React.Fragment key={`${item.id}-${index}`}>
                        <tr>
                          {columnItems.map((column) => (
                            <td
                              key={column.key}
                              className={`align-middle p-2 ${column.className}`}
                            >
                              {column.component
                                ? column.component(item)
                                : item[column.key]}
                            </td>
                          ))}
                        </tr>
                        {collapsible[item.item_code] && (
                          <tr>
                            <td
                              colSpan={columnItems.length}
                              className="p-2 bg-light"
                            >
                              <div className="p-2">
                                <Table className="bg-white" bordered>
                                  <thead className="table-secondary">
                                    <tr>
                                      {columnRacks.map((column) => (
                                        <th
                                          className={`align-middle p-2 ${column.className}`}
                                          key={column.key}
                                        >
                                          <span>{column.label}</span>
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item.racks?.length === 0 && (
                                      <tr>
                                        <td
                                          colSpan={columnRacks.length}
                                          className="p-2 text-center"
                                        >
                                          No data
                                        </td>
                                      </tr>
                                    )}
                                    {item.racks?.length > 0 &&
                                      item.racks.map((item, index) => (
                                        <tr key={`${item.id}-${index}`}>
                                          {columnRacks.map((column) => (
                                            <td
                                              key={column.key}
                                              className={`align-middle p-2 ${column.className}`}
                                            >
                                              {column.component
                                                ? column.component(item)
                                                : item[column.key]}
                                            </td>
                                          ))}
                                        </tr>
                                      ))}
                                  </tbody>
                                </Table>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    )
                  })}
              </tbody>
            </Table>
          </Col>
        </Card>
        <ModalStockAdjustment
          show={Object.values(isOpen).some((value) => value)}
          onHide={handleModal}
          title=""
          size="md"
          backdrop={true}
        >
          <div className="p-2 mt-3 text-center">
            <div className="d-flex justify-content-center">
              <svg
                width="181"
                height="180"
                viewBox="0 0 181 180"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                  fill="#828282"
                />
                <path
                  d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                  fill="#828282"
                />
              </svg>
            </div>
            <div className="my-3">
              <p>{ModalProp().title}</p>
              {ModalProp().description !== '' && (
                <p className="fw-bold">{ModalProp().description}</p>
              )}
            </div>
          </div>
          <Modal.Footer>
            <hr />
            {ModalProp().footer}
          </Modal.Footer>
        </ModalStockAdjustment>
      </Container>
    </>
  )
}

export default CreateManualStockOpname
